<h1 mat-dialog-title>{{ 'organizationAdmin.groups.memberDialog.title' | transloco: { name: data.group.name } }}</h1>

<mat-dialog-content>
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-field">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput [formControl]="searchControl" [placeholder]="'organizationAdmin.groups.memberDialog.searchPlaceholder' | transloco" />
  </mat-form-field>

  <div class="user-list">
    @for (row of filteredRows(); track row.user.id) {
      <div class="user-row">
        <span class="user-row-text">
          <span class="user-name">{{ row.name }}</span>
          <span class="user-email">{{ row.user.email }}</span>
        </span>
        @if (memberIds().has(row.user.id)) {
          <button mat-icon-button type="button" class="remove-button" [matTooltip]="'organizationAdmin.groups.memberDialog.removeTooltip' | transloco" [attr.aria-label]="'organizationAdmin.groups.memberDialog.removeTooltip' | transloco" (click)="toggleMembership(row.user)">
            <mat-icon>remove_circle</mat-icon>
          </button>
        } @else {
          <button mat-icon-button type="button" class="add-button" [matTooltip]="'organizationAdmin.groups.memberDialog.addTooltip' | transloco" [attr.aria-label]="'organizationAdmin.groups.memberDialog.addTooltip' | transloco" (click)="toggleMembership(row.user)">
            <mat-icon>add_circle</mat-icon>
          </button>
        }
      </div>
    }

    @if (filteredRows().length === 0) {
      <p class="empty-text">{{ 'organizationAdmin.groups.memberDialog.noResults' | transloco }}</p>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <span class="dialog-actions-spacer"></span>
  <button mat-button color="primary" type="button" (click)="closeDialog()">
    {{ 'common.buttons.cancel' | transloco }}
  </button>
  <button mat-flat-button color="primary" type="button" (click)="save()">
    <mat-icon>check</mat-icon>
    {{ 'organizationAdmin.groups.memberDialog.done' | transloco }}
  </button>
</mat-dialog-actions>
